import React, { memo, useEffect, useMemo, useState } from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { DRNDateUtil } from '@traveloka/district-util';
import { useLocale } from './context';
import BMText from '../Text/BMText';
import { BMPrimitives, useBMTheme } from '../../theme';
/**
 * WeekBar component.
 *
 * Sen Sel Rab Kam Jum Sab Min
 */
function WeekBar(props) {
    const { activeTheme, BMComponents } = useBMTheme();
    const [styles, setStyles] = useState(() => weekBarStyles(BMComponents));
    const { language } = useLocale();
    const { firstDay, dayColor } = props;
    const sundayIndex = firstDay === 'sun' ? 0 : 6;
    // modify greg-cal's getDays as `toLocaleString` output on Android & iOS is different.
    const dayNames = useMemo(() => {
        let dates = [
            new Date('1995-03-26'),
            new Date('1995-03-27'),
            new Date('1995-03-28'),
            new Date('1995-03-29'),
            new Date('1995-03-30'),
            new Date('1995-03-31'),
            new Date('1995-04-01'),
            new Date('1995-04-02'),
        ];
        if (firstDay === 'sun') {
            dates = dates.slice(0, 7);
        }
        else {
            dates = dates.slice(1, 8);
        }
        return dates.map((d) => DRNDateUtil.dateToString(d, 'iii', { locale: language }));
    }, [firstDay, language]);
    useEffect(() => {
        setStyles(() => weekBarStyles(BMComponents));
    }, [activeTheme]);
    return (<View style={styles.container}>
      {dayNames.map((dayName, index) => {
            const usingLocaleColor = dayColor && Object.keys(dayColor).includes(String(index));
            return (<View key={dayName} style={styles.dayNameContainer}>
            <BMText variant="uiNormal" style={[
                    styles.dayName,
                    {
                        color: index === sundayIndex
                            ? BMComponents.BMUiCalendarInkHoliday
                            : usingLocaleColor
                                ? dayColor[index]
                                : BMComponents.BMStyleTextInkSecondary,
                    },
                ]}>
              {dayName}
            </BMText>
          </View>);
        })}
    </View>);
}
const weekBarStyles = (BMComponents) => StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: BMPrimitives.BMSize.sm,
        ...Platform.select({
            android: { elevation: 1 },
            default: {
                shadowOffset: { height: 1, width: 0 },
                zIndex: 1,
                shadowColor: BMComponents.BMStyleLineBordercolorSubtle,
            },
        }),
        backgroundColor: BMComponents.BMUiCalendarBgcolorPrimary,
    },
    dayNameContainer: {
        flex: 1,
        paddingVertical: BMPrimitives.BMSize.xs,
    },
    dayName: {
        textAlign: 'center',
    },
});
export default memo(WeekBar);
